import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Shield, FileText, Truck } from 'lucide-react';

const Terms: React.FC = () => {
  const { t } = useTranslation();

  const sections = [
    {
      icon: FileText,
      title: t('terms.ordering.title'),
      content: [
        t('terms.ordering.p1'),
        t('terms.ordering.p2'),
      ],
    },
    {
      icon: Truck,
      title: t('terms.delivery.title'),
      content: [
        t('terms.delivery.p1'),
        t('terms.delivery.p2'),
        t('terms.delivery.p3'),
      ],
    },
    {
      icon: Shield,
      title: t('terms.privacy.title'),
      content: [
        t('terms.privacy.p1'),
        t('terms.privacy.p2'),
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 to-premium-50">
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-r from-burgundy-100 via-cream-100 to-premium-100">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center max-w-4xl mx-auto"
          >
            <h1 className="text-5xl md:text-6xl font-serif font-bold text-gray-900 mb-6">
              {t('terms.title')}
            </h1>
            <div className="w-24 h-1 gold-gradient rounded-full mx-auto mb-6"></div>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto space-y-8">
            {sections.map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="premium-card bento-card p-6"
              >
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-burgundy-400 to-burgundy-600 rounded-xl flex items-center justify-center flex-shrink-0">
                    <section.icon className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-serif font-semibold text-gray-900 mb-4">
                      {section.title}
                    </h3>
                    <div className="space-y-2">
                      {section.content.map((p, i) => (
                        <p key={i} className="text-gray-600 leading-relaxed">
                          {p}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;